module.exports = __webpack_public_path__ + "static/audio/narrations_en.f9fb7ca.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/components/music/music/narrations_en.mp3
// module id = JpPU
// module chunks = 1